module.exports = __webpack_public_path__ + "static/media/logo.14d20cc0.svg";